<template>
  <div>
    <cs-app>
      <template v-slot:content>
        <button type="button" @click="fillForm" v-if="notProd">Fill Form</button>
        <form novalidate class="md-layout" @submit.prevent="validateUser">
          <md-card class="md-layout-item md-size-50 md-small-size-100">
            <md-card-header>
              <div class="md-title">Lawyer Signup</div>
            </md-card-header>

            <md-card-content>
              <div class="md-layout md-gutter">

                <!-- First Name -->
                <div class="md-layout-item md-small-size-100">
                  <md-field :class="getValidationClass('firstName', 'profile.firstName')">
                    <label for="first-name">First Name</label>
                    <md-input
                      name="first-name"
                      id="first-name"
                      autocomplete="given-name"
                      v-model="form.firstName"
                      :disabled="sending"
                    />
                    <span
                      class="md-error"
                      v-if="!$v.form.firstName.required"
                    >The first name is required</span>
                    <span
                      class="md-error"
                      v-else-if="!$v.form.firstName.minlength"
                    >Invalid first name</span>
                    <span class="md-error" v-if="backendErrors['profile.firstName']">
                      {{ backendErrors['profile.firstName'].join(' - ') }}
                    </span>
                  </md-field>
                </div>

                <!-- Last Name -->
                <div class="md-layout-item md-small-size-100">
                  <md-field :class="getValidationClass('lastName', 'profile.lastName')">
                    <label for="last-name">Last Name</label>
                    <md-input
                      name="last-name"
                      id="last-name"
                      autocomplete="family-name"
                      v-model="form.lastName"
                      :disabled="sending"
                    />
                    <span
                      class="md-error"
                      v-if="!$v.form.lastName.required"
                    >The last name is required</span>
                    <span class="md-error" v-else-if="!$v.form.lastName.minlength">Invalid last name</span>
                    <span class="md-error" v-if="backendErrors['profile.lastName']">
                      {{ backendErrors['profile.lastName'].join(' - ') }}
                    </span>
                  </md-field>
                </div>
              </div>

              <!-- Password -->
                <div class="md-layout-item md-small-size-100">
                  <md-field :class="getValidationClass('password')">
                    <label for="password">Password</label>
                    <md-input
                      type="password"
                      name="password"
                      id="password"
                      v-model="form.password"
                      :disabled="sending"
                    />
                    <span
                      class="md-error"
                      v-if="!$v.form.password.required"
                    >The password is required</span>
                    <span
                      class="md-error"
                      v-if="!$v.form.password.minLength"
                    >The password must be at least 8 characters long.</span>
                  </md-field>
                </div>


              <div class="md-layout md-gutter">

              <!-- Username -->
              <div class="md-layout-item md-small-size-100">
                <md-field :class="getValidationClass('username')">
                  <label for="username">Username</label>
                  <md-input
                    name="username"
                    id="username"
                    v-model="form.username"
                    :disabled="sending"
                    @change="resetUsernameErrors"
                  />
                  <span class="md-error" v-if="!$v.form.username.required" >The username is required</span>
<!--                  <span class="md-error" v-else-if="!$v.form.username.unique">{{ backendErrors.username.unique.message }}</span>-->
<!--                  <span class="md-error" v-else-if="!$v.form.username.exists">{{ backendErrors.username.exists.message }}</span>-->
                  <span class="md-error" v-if="backendErrors['username']">
                    {{ backendErrors['username'].join(' - ') }}
                  </span>
                  <span class="md-error" v-if="!backendErrors['username'] && $v.form.username.required && !$v.form.username.minlength">Invalid username</span>
                </md-field>

              </div>

                <!-- Sex -->
                <div class="md-layout-item md-small-size-100">
                  <md-field :class="getValidationClass('gender', 'profile.sex')">
                    <label for="gender">Sex</label>
                    <md-select
                      name="gender"
                      id="gender"
                      v-model="form.gender"
                      md-dense
                      :disabled="sending"
                    >
                      <md-option></md-option>
                      <md-option value="male">M</md-option>
                      <md-option value="female">F</md-option>
                    </md-select>
                    <span class="md-error">The gender is required</span>
                    <span class="md-error" v-if="backendErrors['profile.sex']">
                      {{ backendErrors['profile.sex'].join(' - ') }}
                    </span>
                  </md-field>
                </div>

              </div><!-- End of gutter -->

              <!-- Date of Birth -->
              <md-field :class="getValidationClass('dateOfBirth', 'profile.dob')">
                <md-datepicker v-model="form.dateOfBirth">
                  <label>Date of Birth</label>
                </md-datepicker>
                <span class="md-error" v-if="!$v.form.dateOfBirth.required">The DoB is required</span>
                <span class="md-error" v-else-if="!$v.form.dateOfBirth.minValue">DoB must be greater than 18.</span>
                <span class="md-error" v-if="backendErrors['profile.dob']">
                  {{ backendErrors['profile.dob'].join(' - ') }}
                </span>
              </md-field>


              <!-- Email -->
              <md-field :class="getValidationClass('email', 'profile.email')">
                <label for="email">Email</label>
                <md-input
                  type="email"
                  name="email"
                  id="email"
                  autocomplete="email"
                  v-model="form.email"
                  :disabled="sending"
                  @change="resetEmailErrors"
                />
                <span class="md-error" v-if="!$v.form.email.required">The email is required</span>
                <span class="md-error" v-else-if="!$v.form.email.email">Invalid email</span>
                <span class="md-error" v-if="backendErrors['profile.email']">
                  {{ backendErrors['profile.email'].join(' - ') }}
                </span>
              </md-field>

              <!-- Verify Email -->
              <md-field :class="getValidationClass('verifyEmail')">
                <label for="verify-email">Verify Email</label>
                <md-input
                  type="verify-email"
                  name="verify-email"
                  id="verify-email"
                  autocomplete="verify-email"
                  v-model="form.verifyEmail"
                  :disabled="sending"
                />
                <span class="md-error" v-if="!$v.form.verifyEmail.required">You must verify your email</span>
                <span class="md-error" v-else-if="!$v.form.verifyEmail.email">Invalid email</span>
                <span class="md-error" v-else-if="!$v.form.verifyEmail.emailsMatch">Emails must match</span>
              </md-field>

            <div class="md-layout md-gutter">

            <!-- Country Code -->
            <div class="md-layout-item md-size-15">
              <md-field :class="getValidationClass('countryCode')">
                <md-select
                  name="country-code"
                  id="country-code"
                  :disabled="sending"
                  md-dense
                  placeholder="+1"
                >
                  <md-option value="+1" selected>+1</md-option>
                </md-select>
              </md-field>
            </div>

            <!-- Phone -->
            <div class="md-layout-item">
              <md-field :class="getValidationClass('phone', 'profile.phone')">
                <label for="phone">Phone Number</label>
                <md-input
                  type="tel"
                  name="phone"
                  id="phone"
                  placeholder="650-450-1212"
                  autocomplete="tel"
                  v-model="form.phone"
                  :disabled="sending"
                />
                <span class="md-error" v-if="!$v.form.phone.required">The phone number is required</span>
                <span class="md-error" v-if="backendErrors['profile.phone']">
                  {{ backendErrors['profile.phone'].join(' - ') }}
                </span>
              </md-field>
            </div>

            </div>


            <div class="md-layout md-gutter">

            <!-- LSO -->
            <div class="md-layout-item md-small-size-100">
              <md-field :class="getValidationClass('lso', 'profile.lawSocietyNumber')">
                <label for="lso">LSO #</label>
                <md-input
                  @change="resetLsoErrors"
                  name="lso"
                  id="lso"
                  v-model="form.lso"
                  :disabled="sending"
                />
                <span class="md-error" v-if="!$v.form.lso.required">The LSO # is required</span>
                <span class="md-error" v-if="backendErrors['profile.lawSocietyNumber']">
                  {{ backendErrors['profile.lawSocietyNumber'].join(' - ') }}
                </span>

                <!--                <span class="md-error" v-if="!$v.form.lso.unique">{{ backendErrors.lso.unique.message }}</span>-->
<!--                <span class="md-error" v-if="!$v.form.lso.exists">{{ backendErrors.lso.exists.message }}</span>-->
              </md-field>
            </div>


            <!-- Years of Experience -->
            <div class="md-layout-item md-small-size-100">
              <md-field :class="getValidationClass('yearsOfExp', 'profile.yearsOfExperience')">
                <label for="los">Years of Experience</label>
                <md-input
                  type="number"
                  name="years-of-exp"
                  id="years-of-exp"
                  v-model="form.yearsOfExp"
                  :disabled="sending"
                />
                <span class="md-error" v-if="!$v.form.yearsOfExp.required">Years of Experience is required</span>
                <span class="md-error" v-if="backendErrors['profile.yearsOfExperience']">
                  {{ backendErrors['profile.yearsOfExperience'].join(' - ') }}
                </span>
              </md-field>
            </div>

            </div><!-- End of gutter -->

            <!-- Claimed areas of expertise -->
            <md-field :class="getValidationClass('areasOfExpertise', 'profile.areasOfExpertise')">
              <label for="areas-of-expertise">Claimed Area(s) of Expertise</label>
              <md-select
                name="areas-of-expertise"
                id="areas-of-expertise"
                v-model="form.areasOfExpertise"
                :disabled="sending"
                multiple
              >
                <md-option value="slip &amp; fall / trip &amp; fall">Slip &amp; Fall / Trip &amp; Fall</md-option>
                <md-option value="motor vehicle collision">Motor Vehicle Collision</md-option>
              </md-select>
              <span class="md-error" v-if="!$v.form.areasOfExpertise.required">Areas of Expertise is required</span>
              <span class="md-error" v-if="backendErrors['profile.areasOfExpertise']">
                {{ backendErrors['profile.areasOfExpertise'].join(' - ') }}
              </span>
            </md-field>

            <!-- Spoken Languages -->
            <md-field :class="getValidationClass('spokenLanguages', 'profile.spokenLanguages')">
              <label for="spoken-languages">Spoken Languages</label>
              <md-select
                name="spoken-languages"
                id="spoken-languages"
                v-model="form.spokenLanguages"
                :disabled="sending"
                multiple
              >
                <md-option
                  :value="language.value"
                  v-for="language in languageOptions"
                  :key="language.id">{{ language.name }}</md-option>
              </md-select>
              <span class="md-error" v-if="!$v.form.areasOfExpertise.required">Spoken languages are required</span>
              <span class="md-error" v-if="backendErrors['profile.spokenLanguages']">
                {{ backendErrors['profile.spokenLanguages'].join(' - ') }}
              </span>
            </md-field>

            <!-- Firm Size -->
            <md-field :class="getValidationClass('firmSize', 'profile.firmSize')">
              <label for="firm-size">Firm Size (No. Lawyers)</label>
              <md-input
                type="number"
                name="firm-size"
                id="firm-size"
                v-model="form.firmSize"
                :disabled="sending"
              />
              <span class="md-error" v-if="!$v.form.firmSize.required">Firm size is required</span>
              <span class="md-error" v-if="backendErrors['profile.firmSize']">
                {{ backendErrors['profile.firmSize'].join(' - ') }}
              </span>
            </md-field>


            <!-- Firm Address -->
            <div class="md-title" style="margin-top: 40px;">Firm Address</div>

            <!-- Street number -->
              <md-field :class="getValidationClass('address.line1')">
                <label for="address-line-1">Address Line 1</label>
                <md-input
                  name="address-line-1"
                  id="address-line-1"
                  v-model="form.address.line1"
                  :disabled="sending"
                />
                <span class="md-error" v-if="!$v.form.address.line1.required">Address Line 1 is required</span>
              </md-field>

            <!-- Apt Number -->
              <md-field :class="getValidationClass('address.line2')">
                <label for="address-line-2">Address Line 2</label>
                <md-input
                  name="address-line-2"
                  id="address-line-2"
                  v-model="form.address.line2"
                  :disabled="sending"
                />
              </md-field>

            <!-- City -->
              <md-field :class="getValidationClass('address.city')">
                <label for="city">City</label>
                <md-input
                  name="city"
                  id="city"
                  v-model="form.address.city"
                  :disabled="sending"
                />
                <span class="md-error" v-if="!$v.form.address.city.required">City is required</span>
              </md-field>

            <!-- Province -->
              <md-field :class="getValidationClass('address.province')">
                <label for="province">Province (Ontario only)</label>
                <md-select
                  name="province"
                  id="province"
                  v-model="form.address.province"
                  :disabled="sending"
                >
                  <md-option value="ON">Ontario</md-option>
                </md-select>
                <span class="md-error" v-if="!$v.form.address.province.required">Province is required</span>
              </md-field>

            <!-- Country -->
              <md-field :class="getValidationClass('address.country')">
                <label for="country">Country (Canada only)</label>
                <md-select
                  name="country"
                  id="country"
                  v-model="form.address.country"
                  :disabled="sending"
                >
                  <md-option value="CA">Canada</md-option>
                </md-select>
                <span class="md-error" v-if="!$v.form.address.country.required">Country is required</span>
              </md-field>

            <!-- Payment Info -->
            <div class="md-title" style="margin: 40px 0;">Payment Info</div>
            <div ref="card"></div>

            <div v-if="notProd">
              <div>4000001240000000</div>
            </div>

            </md-card-content>

            <md-progress-bar md-mode="indeterminate" v-if="sending"/>

            <md-card-actions>
              <md-button type="submit" class="md-primary" :disabled="sending" @click="validateUser">Create user</md-button>
            </md-card-actions>
          </md-card>

          <md-snackbar :md-active.sync="userSaved">The user {{ lastUser }} was saved with success!</md-snackbar>

          <md-snackbar
             :md-active.sync="showErrorsSnackBack" md-persistent>
            <span>{{ snackbarMessage }}</span>
            <md-button class="md-primary" @click="showErrorsSnackBack = false">Dismiss</md-button>
          </md-snackbar>
        </form>
      </template>
    </cs-app>
  </div>
</template>

<script>
import moment from 'moment'
import { paymentGateway } from '@/services/paymentGateway'
import CSApp from "@/components/CSApp";
import { validationMixin } from "vuelidate";
import {
  required,
  email,
  minLength,
  maxLength
} from "vuelidate/lib/validators";
import PaymentForm from '@/components/PaymentForm'
import { lawyerTransformer } from '@/data/lawyerTransformer'
import ISO6391 from 'iso-639-1'
import _ from 'lodash'
import { lawyerErrorsTransformer, setFormErrors } from '@/data/lawyerErrorsTransformer'
import { appEnvNotProd } from '@/utilities/appEnvNotProd'

let customUnique = (obj) => (value) => {
  return obj.message ? false : true
}

let customExists = (obj) => (value) => {
  return obj.message ? false : true
}

const customEmail = (obj) => (value) => {
  return obj.message ? false : true
}

export default {
  name: "LawyerSignupPage",
  components: {
    "cs-app": CSApp,
    PaymentForm,
  },
  mixins: [validationMixin],
  data: () => ({
    stripe: Stripe(`${process.env.VUE_APP_STRIPE_PUBLIC_KEY}`),
    card: null,

    showErrorsSnackBack: false,
    snackbarMessage: 'Error! The submited form was invalid.',
    defaultSnackbarMessage: 'Error! The submited form was invalid.',
    languageOptions: [],
    form: {
      password: null,
      paymentToken: null,
      firstName: null,
      lastName: null,
      username: null,
      dateOfBirth: null,
      gender: null,
      email: null,
      verifyEmail: null,
      countryCode: '+1',
      phone: null,
      lso: null,
      yearsOfExp: null,
      areasOfExpertise: [],
      spokenLanguages: [],
      firmSize: null,
      address: {
        line1: null,
        line2: null,
        streetName: null,
        city: null,
        province: null,
        country: null,
        postalCode: null,
      }
    },
    userSaved: false,
    sending: false,
    lastUser: null,
    backendErrors: {},
  }),
  computed: {
    notProd: () => appEnvNotProd()
  },
  validations () {
    return {
      form: {
        firstName: {
          required,
          minLength: minLength(3)
        },
        lastName: {
          required,
          minLength: minLength(3)
        },
        username: {
          // unique: customUnique(this.backendErrors.username.unique),
          // exists: customExists(this.backendErrors.username.exists),
          required,
          minLength: minLength(3)
        },
        dateOfBirth: {
          required,
          minValue: value => {
            if (value === null) {
              return false;
            }
            return value.toISOString() < moment().subtract(18, 'years').toISOString()
          }
        },
        gender: {
          required
        },
        email: {
          required,
          email,
          // unique: customUnique(this.backendErrors.email.unique),
          // backendEmail: customEmail(this.backendErrors.email.valid),
        },
        verifyEmail: {
          required,
          email,
          emailsMatch: function (value) { return value === this.form.email }
        },
        phone: {
          required,
        },
        lso: {
          // unique: customUnique(this.backendErrors.lso.unique),
          // exists: customExists(this.backendErrors.lso.exists),
          required,
        },
        yearsOfExp: {
          required,
        },
        areasOfExpertise: {
          required,
        },
        spokenLanguages: {
          required
        },
        firmSize: {
          required
        },
        address: {
          line1: {
            required
          },
          city: {
            minLength: minLength(1),
            required
          },
          province: {
            minLength: minLength(2),
            required
          },
          country: {
            minLength: minLength(2),
            required
          }
        },
        password: {
          required,
          minLength: minLength(8)
        }
      }
    }
  },
  methods: {
    getValidationClass(fieldName, backendFieldName = null) {

      backendFieldName = backendFieldName || fieldName

      let field = _.get(this.$v.form, fieldName);
      let invalid = (field ? field.$invalid && field.$dirty : false)

      if (_.get(this.backendErrors, backendFieldName)) {
        invalid = true
      }

      return {
        "md-invalid": invalid
      };

    },
    resetUsernameErrors () {
      delete this.backendErrors.username
    },
    resetEmailErrors () {
      delete this.backendErrors.email
    },
    resetLsoErrors () {
      delete this.backendErrors.lso
    },
    saveUser() {
      this.sending = true;

      // First try to get a stripe payment token
      paymentGateway(this.stripe, this.card).createToken().then(response => {
        if (response.error) {
          this.sending = false;
          this.showErrorsSnackBack = true;
          this.snackbarMessage = response.error.message;
          return;
        }
        if (!response.error) {
          let paymentToken = response.token.id
          let postalCode = response.token.card.address_zip
          this.$http.post(`${process.env.VUE_APP_API_URL}/signup-lawyer`, lawyerTransformer({
            ...this.form,
            paymentToken,
            postalCode,
            })).then(response => {
                this.lastUser = `${this.form.firstName} ${this.form.lastName}`;
                this.userSaved = true;
                this.sending = false;
                this.$user.logIn(response.data.accessToken, response.data.user.roles[0].role)
                this.$http.setAuthHeaders();
                this.$router.push({name: 'lawyer.cases.index'})
            }).catch(error => {
              this.sending = false
              // let errorBag = lawyerErrorsTransformer(error.response.data)
              // this.backendErrors = setFormErrors(errorBag, this.backendErrors)

              this.parseBackendErrors(error.response.data.message)

              this.$v.$touch()
              this.$forceUpdate()
              this.showErrorsSnackBack = true;

              const responseData = error.response.data

              let message = null
              switch (responseData.statusCode) {
                case 403:
                  if (responseData.message.includes('ip address')) {
                    message = responseData.message
                  }
                  break
              }

              this.snackbarMessage = message || this.defaultSnackbarMessage
            })
        }
      }).catch(error => console.log(error));
    },
    validateUser() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        this.saveUser();
        return;
      }

      this.showErrorsSnackBack = true;
      this.snackbarMessage = this.defaultSnackbarMessage;
    },
    fillForm() {
      let fakeLawyer = this.$factory('Lawyer').make();

      this.form.password = fakeLawyer.password
      this.form.firstName = fakeLawyer.firstName
      this.form.lastName = fakeLawyer.lastName
      this.form.username = fakeLawyer.username
      this.form.gender = fakeLawyer.gender
      this.form.dateOfBirth = fakeLawyer.dateOfBirth
      this.form.email = fakeLawyer.email
      this.form.verifyEmail = fakeLawyer.email
      this.form.phone = '519-555-5555'
      this.form.lso = '123456ABC' // fakeLawyer.lso
      this.form.yearsOfExp = fakeLawyer.yearsOfExp
      this.form.areasOfExpertise = ['slip & fall / trip & fall']
      this.form.spokenLanguages = ['afar']
      this.form.firmSize = fakeLawyer.firmSize
      this.form.address.line1 = "416 Citation Dr"
      this.form.address.city = "London"
      this.form.address.province = "ON"
      this.form.address.country = "CA"
    },
    parseBackendErrors(data = []) {
      let errors = {}

      if (Array.isArray(data)) {

        data.forEach(field => {

          if (field.constraints) {
            errors[field.property] = Object.values(field.constraints)
          }

          if (_.get(field, 'children', null)) {
            field.children.forEach(child => {
              errors[`${field.property}.${child.property}`] = Object.values(child.constraints)
            })
          }
        })

      }

      this.$set(this, 'backendErrors', errors)
    },
  },
  created () {
    this.languageOptions = ISO6391.getAllNames().map((name, id) => ({id, name, value: name.toLowerCase()}))
  },
  mounted() {
    let style = {
      base: {
        color: '#32325d',
        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
        fontSmoothing: 'antialiased',
        fontSize: '16px',
        '::placeholder': {
          color: '#aab7c4'
        }
      },
      invalid: {
        color: '#fa755a',
        iconColor: '#fa755a'
      }
    };

    const elements = this.stripe.elements()
    this.card = elements.create('card', style);
    this.card.mount(this.$refs.card);
  }
};
</script>

<style lang="scss" scoped>

form {
    justify-content: center;
}

</style>